/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Sources_Document_DeleteInputs */



/**
* | output |
* | --- |
* | "Delete document" |
*
* @param {Meeting_Sources_Document_DeleteInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_document_delete = /** @type {((inputs?: Meeting_Sources_Document_DeleteInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_Document_DeleteInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Document verwijderen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le document")
	return /** @type {LocalizedString} */ ("Delete document")
});